//MODEL: custom model object : { domain: instance of Domain }

define('app/editor/dialogs/SelectMonitorDefinitionDialogView',['require','glu/itemView','glu/$','hbs!./SelectMonitorDefinitionDialogView.hbs'],function(require) {
	'use strict';

	var ItemView = require('glu/itemView'),
		$ = require('glu/$');

	var view = ItemView.extend({

		template: require('hbs!./SelectMonitorDefinitionDialogView.hbs'),

		ui: {
			$searchTxt: '[name=searchTxt]',
			$radioMetrics: '#content-mode-metrics',
			$radioSegments: '#content-mode-segments',
			$metricsContent: '.select-metrics-content',
			$segmentsContent: '.select-segments-content',
			$metricsNotFound: '.select-metrics-content .norecordsfound',
			$segmentsNotFound: '.select-segments-content .norecordsfound'
		},

		events: {
			'submit form': 'submitForm',
			'keyup [name="searchTxt"]': 'updateView',
			'change [name="content-mode"]': 'updateContentView'
		},

		dialogTitle: 'Select Metrics / Segments',

		getClass: function() {
			return this.className || 'modal-select-metrics';
		},

		dialogButtons: [{
			text: 'Add Metrics / Segments',
			callback: 'announceSelected',
			className: 'btn-primary'
		}],

		initialize: function() {
			if (this.options) {
				this.dialogTitle = this.options.dialogTitle || this.dialogTitle;
				this.dialogButtons = this.options.dialogButtons || this.dialogButtons;
				this.viewMode = this.options.viewMode || this.viewMode;
				this.className = this.options.className || this.className;
				this.modalClass = this.options.modalClass || this.modalClass;
			}
		},

		onRender: function() {
			var self = this;
			if (this.options.mode === 'metrics') {
				this.ui.$radioMetrics.prop('checked', true);
			} else {
				this.ui.$radioSegments.prop('checked', true);
			}
			this.updateContentView();
			this.ui.$metricsNotFound.hide();
			this.ui.$segmentsNotFound.hide();

			setTimeout(function() {
				self.$('.search-column-name').width(self.$el.width() - 10);
			}, 0);
		},

		submitForm: function(e) {
			e.preventDefault();
			$(e.target).find('input[name="searchTxt"]').blur();
		},

		hasMetrics: function() {
			return this.metrics().length > 0;
		},

		metrics: function() {
			var domain = this.model.get('domain');
			return domain.getMetrics();
		},

		hasSegments: function() {
			return this.segments().length > 0;
		},

		segments: function() {
			var domain = this.model.get('domain');
			return domain.getSegments();
		},

		announceSelected: function() {
			var metricIds = this.$el.find('input.metric:checked').map(function(i, el) {
					return el.getAttribute('data-field-id');
				}).toArray(),

				segmentIds = this.$el.find('.select-segments-content input[type="checkbox"]:checked').map(function(i, el) {
					return el.getAttribute('data-field-id');
				}).toArray();

			this.trigger('thisdialog:selectedefinition', metricIds, segmentIds);
		},

		updateView: function() {
			var self = this;
			var searchTxt = this.ui.$searchTxt.val();
			var $tables = this.$el.find('table');
			var $rows = this.$el.find('tr.parent, tr.child-columns');
			var $children = self.$el.find('tr.child-columns');
			var $showMessages = self.$el.find('tr.child-columns-message');

			if (searchTxt) {
				$children.show();

				// hide all the fields that does not include the searchTxt in it
				for (var i = 0; i < $rows.length; i++) {
					var containsText = $($rows[i]).text().toLowerCase().indexOf(searchTxt.toLowerCase()) !== -1;

					$($rows[i]).show();
					$($rows[i]).removeClass('hidden');

					if (!containsText) {
						if (!$($rows[i]).hasClass('active') && $($rows[i]).find('input:checked').length === 0) {
							$($rows[i]).addClass('hidden');
							$($rows[i]).hide();
						}
					} else {
						$($rows[i]).prevUntil('tr.parent').prev('tr.parent').show();
						$($rows[i]).prevUntil('tr.parent').prev('tr.parent').removeClass('hidden');
					}
				}

				window.setTimeout(function() {
					$.each($tables, function(index, val) {
						if ($(val).find('> tbody').children().length === $(val).find('> tbody').children('.hidden').length) {
							$(val).parent().find('.norecordsfound').show();
						} else {
							$(val).parent().find('.norecordsfound').hide();
						}
					});
				}, 0);

				$showMessages.hide();
			} else {
				$tables.parent().show();
				$tables.parent().find('.norecordsfound').hide();
				$rows.show();
				$rows.removeClass('hidden');
				$children.hide();
				$showMessages.show();
			}
		},

		updateContentView: function() {
			if (this.ui.$radioMetrics.prop('checked') === true) {
				this.ui.$segmentsContent.hide();
				this.ui.$metricsContent.show();
				$('.modal-select-filters .btn-filters').removeClass('hidden');
				$('.modal-select-filters .btn-segments').addClass('hidden');
			} else if (this.ui.$radioSegments.prop('checked') === true) {
				this.ui.$segmentsContent.show();
				this.ui.$metricsContent.hide();
				$('.modal-select-filters .btn-filters').addClass('hidden');
				$('.modal-select-filters .btn-segments').removeClass('hidden');
			}
		},

		cancel: function() {
			this.trigger('closeModal');
		},

		serializeData: function() {
			return this;
		}

	});

	return view;
});

